module.exports = __webpack_public_path__ + "static/media/play.44a419a2.svg";